// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-AppDetails-AppDetails-module__container--3hmeK"};